var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "wrap",
      style: {
        backgroundImage: _vm.imgShow.sysBgcUrl
          ? "url(" + _vm.sysBgcUrl + ")"
          : "",
      },
    },
    [
      _c("div", { staticClass: "sys-logo" }, [
        _vm.imgShow.logoSrc
          ? _c("img", { attrs: { src: _vm.logoSrc, alt: "" } })
          : _vm._e(),
        _vm._v(" "),
        _vm.logoIntroduction
          ? _c("div", { staticClass: "introduction" }, [
              _vm._v("\n      " + _vm._s(_vm.logoIntroduction) + "\n      "),
              _c("a", { attrs: { href: _vm.logoUrl, target: "_blank" } }, [
                _vm._v("Here"),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "sys-footer" }, [
        _vm.bottomIntroduction
          ? _c("div", { staticClass: "introduction" }, [
              _vm._v("\n      " + _vm._s(_vm.bottomIntroduction) + "\n      "),
              _c("a", { attrs: { href: _vm.bottomUrl, target: "_blank" } }, [
                _vm._v("Here"),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("span", { staticStyle: { "padding-right": "5px" } }, [
          _vm._v(_vm._s(_vm.$t("copyright"))),
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticStyle: { "margin-left": "10px" },
            attrs: {
              href: "https://beian.miit.gov.cn/#/Integrated/index",
              target: "_blank",
            },
          },
          [_vm._v(_vm._s(_vm.$t("forTheRecord")))]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "login-wrap" }, [
        _c(
          "div",
          { staticClass: "lang-select" },
          [
            _c("LangSelect"),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { type: "primary", size: "mini" },
                on: { click: _vm.onBack },
              },
              [_vm._v(_vm._s(_vm.$t("login.back")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _vm.optionType === "preLogin"
          ? _c(
              "div",
              { staticClass: "login-box box" },
              [
                _c("div", { staticClass: "login-tips login-tips-hello" }, [
                  _vm._v(_vm._s(_vm.$t("login.hello"))),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "login-tips" }, [
                  _vm._v(_vm._s(_vm.$t("login.welcomeToSignIn"))),
                ]),
                _vm._v(" "),
                _c(
                  "el-form",
                  {
                    ref: "loginForm",
                    attrs: { model: _vm.loginForm, rules: _vm.loginFormRules },
                    nativeOn: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return _vm.onPreLogin("loginForm")
                      },
                    },
                  },
                  [
                    !_vm.disablePasswordLogin
                      ? [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "username",
                                label: _vm.$t("login.emailAccount"),
                              },
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.loginForm.username,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.loginForm, "username", $$v)
                                  },
                                  expression: "loginForm.username",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "password",
                                label: _vm.$t("login.password"),
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { type: "password" },
                                model: {
                                  value: _vm.loginForm.password,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.loginForm, "password", $$v)
                                  },
                                  expression: "loginForm.password",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "forgot-password" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text", size: "mini" },
                                  on: { click: _vm.onForgotPassword },
                                },
                                [_vm._v(_vm._s(_vm.$t("login.forgotPassword")))]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "btn",
                                  attrs: {
                                    type: "primary",
                                    "native-type": "submit",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("login.signIn")))]
                              ),
                            ],
                            1
                          ),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "btn",
                            attrs: { type: "success" },
                            on: { click: _vm.onMicrosoftLogin },
                          },
                          [_vm._v(_vm._s(_vm.$t("login.signInWithMicrosoft")))]
                        ),
                      ],
                      1
                    ),
                  ],
                  2
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.optionType === "thirdParty"
          ? _c(
              "div",
              { staticClass: "login-box box" },
              [
                _c("div", { staticClass: "login-tips login-tips-hello" }, [
                  _vm._v(_vm._s(_vm.$t("login.hello"))),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "login-tips" }, [
                  _vm._v(
                    _vm._s(
                      _vm.thirdPartySource === "microsoft"
                        ? _vm.$t("login.signInWithMicrosoft")
                        : _vm.$t("login.thirdPartyLogin")
                    )
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "el-form",
                  {
                    ref: "thirdPartyForm",
                    attrs: {
                      model: _vm.thirdPartyForm,
                      rules: _vm.thirdPartyFormRules,
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "configId" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { placeholder: "" },
                            model: {
                              value: _vm.thirdPartyForm.configId,
                              callback: function ($$v) {
                                _vm.$set(_vm.thirdPartyForm, "configId", $$v)
                              },
                              expression: "thirdPartyForm.configId",
                            },
                          },
                          _vm._l(_vm.thirdPartyConfigList, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.alias, value: item.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "back-to-login-btn" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "mini" },
                            on: { click: _vm.onBackToLoginPage },
                          },
                          [_vm._v(_vm._s(_vm.$t("login.backToLoginPage")))]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "btn",
                            attrs: { type: "success" },
                            on: { click: _vm.onThirdPartyConfirm },
                          },
                          [_vm._v(_vm._s(_vm.$t("login.signIn")))]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.optionType === "login"
          ? _c(
              "div",
              { staticClass: "account-box box" },
              [
                _c("div", { staticClass: "login-tips" }, [
                  _vm._v(_vm._s(_vm.$t("login.chooseAnAccount"))),
                ]),
                _vm._v(" "),
                _c(
                  "el-form",
                  {
                    ref: "accountForm",
                    attrs: {
                      model: _vm.accountForm,
                      rules: _vm.accountFormRules,
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "agentTenantId" } },
                      [
                        _c("vue-select-page", {
                          staticClass: "vue-select-page",
                          attrs: {
                            multiple: false,
                            filterable: true,
                            clearable: true,
                            options: _vm.tenantList,
                            "label-key":
                              _vm.language === "zh"
                                ? "{chineseName|name}-{partyId}"
                                : "{name|chineseName}-{partyId}",
                            "value-key": "partyId",
                          },
                          model: {
                            value: _vm.accountForm.agentTenantId,
                            callback: function ($$v) {
                              _vm.$set(_vm.accountForm, "agentTenantId", $$v)
                            },
                            expression: "accountForm.agentTenantId",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "btn",
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.onLogin("accountForm")
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("login.signIn")))]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.optionType === "retrieve",
                expression: "optionType === 'retrieve'",
              },
            ],
            staticClass: "retrieve-box box",
          },
          [
            _c("div", { staticClass: "login-tips" }, [
              _vm._v(_vm._s(_vm.$t("login.retrievePassword"))),
            ]),
            _vm._v(" "),
            _c(
              "el-form",
              {
                ref: "retrieveForm",
                attrs: {
                  model: _vm.retrieveForm,
                  rules: _vm.retrieveFormRules,
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "email" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: _vm.$t("common.userEmail") },
                      model: {
                        value: _vm.retrieveForm.email,
                        callback: function ($$v) {
                          _vm.$set(_vm.retrieveForm, "email", $$v)
                        },
                        expression: "retrieveForm.email",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "back-to-login-btn" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "mini" },
                        on: { click: _vm.onBackToLoginPage },
                      },
                      [_vm._v(_vm._s(_vm.$t("login.backToLoginPage")))]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "btn",
                        attrs: {
                          type: "primary",
                          disabled: +_vm.timeOutTime > 0,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onSendEmail("retrieveForm")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              +_vm.timeOutTime > 0
                                ? _vm.$t("login.sendEmail") +
                                    " " +
                                    _vm.timeOutTime +
                                    "s"
                                : _vm.$t("login.sendEmail")
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _vm.optionType === "reset"
          ? _c(
              "div",
              { staticClass: "reset-box box" },
              [
                _c("div", { staticClass: "login-tips" }, [
                  _vm._v(_vm._s(_vm.$t("login.resetPassword"))),
                ]),
                _vm._v(" "),
                _c(
                  "el-form",
                  {
                    ref: "resetForm",
                    attrs: { model: _vm.resetForm, rules: _vm.resetFormRules },
                  },
                  [
                    !_vm.aggregatorIsSystemPwd
                      ? _c(
                          "el-form-item",
                          { attrs: { prop: "password" } },
                          [
                            _c("el-input", {
                              attrs: {
                                type: "password",
                                placeholder: _vm.$t("navbar.newPassword"),
                              },
                              model: {
                                value: _vm.resetForm.password,
                                callback: function ($$v) {
                                  _vm.$set(_vm.resetForm, "password", $$v)
                                },
                                expression: "resetForm.password",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.aggregatorIsSystemPwd
                      ? _c(
                          "el-form-item",
                          { attrs: { prop: "password2" } },
                          [
                            _c("el-input", {
                              attrs: {
                                type: "password",
                                placeholder: _vm.$t("navbar.confirmpassword"),
                              },
                              model: {
                                value: _vm.resetForm.password2,
                                callback: function ($$v) {
                                  _vm.$set(_vm.resetForm, "password2", $$v)
                                },
                                expression: "resetForm.password2",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "back-to-login-btn" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "mini" },
                            on: { click: _vm.onBackToLoginPage },
                          },
                          [_vm._v(_vm._s(_vm.$t("login.backToLoginPage")))]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "btn",
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.onResetForm("resetForm")
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("login.resetPassword")))]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        ["change", "set"].includes(_vm.optionType)
          ? _c(
              "div",
              { staticClass: "change-box box" },
              [
                _c("div", { staticClass: "login-tips" }, [
                  _vm._v(
                    _vm._s(
                      _vm.aggregatorIsSystemPwd
                        ? _vm.$t("login.resetPassword")
                        : _vm.optionType === "change"
                        ? _vm.$t("navbar.changePassword")
                        : _vm.$t("login.setPassword")
                    )
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "el-form",
                  {
                    ref: "changeForm",
                    attrs: {
                      model: _vm.changeForm,
                      rules: _vm.changeFormRules,
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "oldPassword" } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "password",
                            placeholder: _vm.$t("login.currentPassword"),
                          },
                          model: {
                            value: _vm.changeForm.oldPassword,
                            callback: function ($$v) {
                              _vm.$set(_vm.changeForm, "oldPassword", $$v)
                            },
                            expression: "changeForm.oldPassword",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !_vm.aggregatorIsSystemPwd
                      ? _c(
                          "el-form-item",
                          { attrs: { prop: "password" } },
                          [
                            _c("el-input", {
                              attrs: {
                                type: "password",
                                placeholder: _vm.$t("navbar.newPassword"),
                              },
                              model: {
                                value: _vm.changeForm.password,
                                callback: function ($$v) {
                                  _vm.$set(_vm.changeForm, "password", $$v)
                                },
                                expression: "changeForm.password",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.aggregatorIsSystemPwd
                      ? _c(
                          "el-form-item",
                          { attrs: { prop: "password2" } },
                          [
                            _c("el-input", {
                              attrs: {
                                type: "password",
                                placeholder: _vm.$t("navbar.confirmpassword"),
                              },
                              model: {
                                value: _vm.changeForm.password2,
                                callback: function ($$v) {
                                  _vm.$set(_vm.changeForm, "password2", $$v)
                                },
                                expression: "changeForm.password2",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "back-to-login-btn" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "mini" },
                            on: { click: _vm.onBackToLoginPage },
                          },
                          [_vm._v(_vm._s(_vm.$t("login.backToLoginPage")))]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "btn",
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.onChangeForm("changeForm")
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.aggregatorIsSystemPwd
                                  ? _vm.$t("login.resetPassword")
                                  : _vm.optionType === "change"
                                  ? _vm.$t("navbar.changePassword")
                                  : _vm.$t("login.setPassword")
                              )
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }